(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('NumberService', NumberService);

  NumberService.$inject = ['$resource'];

	 function NumberService ($resource) {
    return $resource(apiUrl + '/channels/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true }
    });
  }
})();
